import gql from 'graphql-tag';

const key = `UpdateMemberStatus`;
const mutation = gql`
mutation ${key}($memberId: ID!, $inactive: Boolean!, $status: UserStatus) {
  updateMember(input:{
    id: $memberId
    inactive: $inactive
  }){
    id
  }
  
  updateCognitoUser(
    id: $memberId
    status: $status
  )
}
`;

export const UPDATE_MEMBER_STATUS = { key, mutation };
